export default __webpack_public_path__ + "static/media/AM_00786 copy.a1d707c8.jpg";